// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { reyaNetwork as _reyaNetwork } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the reyaNetwork chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1729
 * Chain Name: Reya Network
 * Default Block Explorer: https://explorer.reya.network
 * Default RPC URL: https://rpc.reya.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { reyaNetwork } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: reyaNetwork,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const reyaNetwork = createCommon({
	..._reyaNetwork,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
